export const OAUTH_URL = 'security/v2/oauth';
export const ACCOUNT_URL = 'security/v2/account';
export const MODULES_URL = 'security/v2/modules';
export const IDENTITY_URL = 'security/v2/identity';
export const EXTERNAL_LINKS_URL = 'v2/externallinks';
